module.exports = __webpack_public_path__ + "img/nodeport.2163cf57.svg";